<a
  #triggerElement1
  class="switching-profile switching-profile__content flex items-center gap-[4px] cursor-pointer focus:!rounded-[0.188rem] focus:!bg-[#242a48] focus:!shadow-[0_0_0_2px_#616778] focus:!outline-transparent focus:!outline-2"
  href="javascript:void(0)"
  (click)="openProfileSelectorModal($event)"
  (keydown.enter)="openProfileSelectorModal($event)"
  [attr.data-acdl-action]="'header:profile selector click'"
  [attr.data-acdl-page-section]="'header:profile selector'"
  [attr.data-acdl-name]="content.displayTravelType?.toLowerCase()"
>
  <span
    class="switching-profile__label text-right text-inverse text-caption-medium max-w-[65px] overflow-hidden text-ellipsis whitespace-nowrap"
  >
    {{ content.displayTravelType }}
  </span>
  <span class="switching-profile__toggle">
    <svg
      class="switching-profile__icon"
      [ngClass]="{
        'switching-profile__icon--rotated rotate-180': flyoutToggle
      }"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.99854 6L0.498535 2H7.49854L3.99854 6Z"
        fill="white"
      />
    </svg>
  </span>
</a>
